import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { IContext, primaryButton, label, table, secondaryButton } from 'msteams-ui-styles-core'

import { GridDataResult, DataStateChangeEvent, FilterService } from '@progress/kendo-angular-grid';
import { State, process, SortDescriptor, FilterDescriptor, CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { NotificationService } from '@progress/kendo-angular-notification';

import { MsTeamsContextProvider } from '../core/providers/msteamscontext.provider';
import { AuthenticationProvider } from '../core/providers/authentication.provider';

import { TeamRequestService } from '../core/services/team-request.service';

import { TeamRequest } from '../shared/models/team-request';
import { Constants } from '../shared/constants';
import { TeamRequestTypes } from '../shared/models/team-request-types';
import { TeamRequestStates } from '../shared/models/team-request-states';
import { OrganisationUnit } from '../shared/models/organisation-unit';

const flatten = filter => {
  const filters = (filter || {}).filters;
  if (filters) {
    return filters.reduce((acc, curr) => acc.concat(curr.filters ? flatten(curr) : [curr]), []);
  }
  return [];
};

const distinctTeamRequestTypes = data => data
  .map(req => ({ id: req.typeId, name: req.typeName }))
  .filter((x, idx, xs) => xs.findIndex(y => y.id === x.id) === idx);

const distinctRequestOrganisationUnits = data => data
  .map(req => ({ id: req.organisationUnitId, name: req.organisationUnitName }))
  .filter((x, idx, xs) => xs.findIndex(y => y.id === x.id) === idx);

const distinctTeamRequestStates = data => data
  .map(req => ({ id: req.stateId, name: req.stateName }))
  .filter((x, idx, xs) => xs.findIndex(y => y.id === x.id) === idx);



@Component({
  selector: 'app-team-requests-to-approve',
  templateUrl: './team-requests-to-approve.component.html',
  styleUrls: ['./team-requests-to-approve.component.css']
})
export class TeamRequestsToApproveComponent implements OnInit {

  // props for layout  
  @Input() appContext: IContext;

  cssBtnPrimary: string;
  cssBtnSecondary: string;
  msTable;

  TEAMREQUESTSTATE_REQUESTED: number = Constants.TEAMREQUESTSTATE_REQUESTED;

  // props for request table
  public teamRequestsToApprove: TeamRequest[];
  public teamRequestsToApproveData: GridDataResult;


  public state: State = {
    skip: 0,
    take: 10,

    // Initial filter descriptor
    filter: {
      logic: 'and',
      filters: [{ field: 'stateId', operator: 'eq', value: this.TEAMREQUESTSTATE_REQUESTED }]
    },

    sort: [{
      field: 'scaCreatedOn',
      dir: 'desc'
    }]
  };

  public teamRequestsTypes: TeamRequestTypes[] = [];
  public teamRequestsOrganisationUnits: OrganisationUnit[] = [];
  public teamRequestsStates: TeamRequestStates[] = [];

  public selectedTeamRequestsTypeId: number;
  public selectedTeamRequestsOrganisationUnitId: number;
  public selectedTeamRequestsStateId: number = this.TEAMREQUESTSTATE_REQUESTED;

  public actualUser: string;
  public isActualUserAdmin: boolean;
  public isActualUserApprovalUser: boolean = true;

  public showIds: boolean = false;
  public isShowAllChecked: boolean = false;

  constructor(private _msTeamsContextProvider: MsTeamsContextProvider,
              private _teamsRequestsService: TeamRequestService,
              private _authenticationProvider: AuthenticationProvider,
              private router: Router,
              private _route: ActivatedRoute,
              private _notificationService: NotificationService)
  {     
     
  }

  ngOnInit() {

    // get actual user
    this._route.queryParamMap.subscribe(queryParams => {
      if (queryParams.get("userPrincipal")) {
        this.actualUser = queryParams.get("userPrincipal").toLowerCase();
      }
      else {
        this.router.navigate(['/access-denied']);
      }    
      console.log("userPrincipal:" + this.actualUser);
    })

    this._authenticationProvider.isAdmin(this.actualUser).subscribe(result => {
      this.isActualUserAdmin = result;
    });

    this._authenticationProvider.isApproval(this.actualUser).subscribe(result => {
      this.isActualUserApprovalUser = result;
    });

    // Here is the magic.
    var context = this._msTeamsContextProvider.getContext();

    this.cssBtnPrimary = primaryButton(context);
    this.cssBtnSecondary = secondaryButton(context);
    this.msTable = table(context);

    this.loadData();
  }

  public teamRequestsToApprovefilterChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.teamRequestsToApproveData = process(this.teamRequestsToApprove, this.state);

    const [filterSelectedTeamRequestsType] = flatten(this.state).filter(x => x.field === 'typeId');
    if (!filterSelectedTeamRequestsType) {
      this.selectedTeamRequestsTypeId = undefined;
    }

    const [filterSelectedTeamRequestsOrganisationUnit] = flatten(this.state).filter(x => x.field === 'organisationUnitId');
    if (!filterSelectedTeamRequestsOrganisationUnit) {
      this.selectedTeamRequestsOrganisationUnitId = undefined;
    }

    const [filterSelectedTeamRequestsState] = flatten(this.state).filter(x => x.field === 'stateId');
    if (!filterSelectedTeamRequestsState) {
      this.selectedTeamRequestsStateId = undefined;
    }
  }

  public teamRequestsToApprovesortChange(sort: SortDescriptor[]): void {
    this.state.sort = sort;
    this.teamRequestsToApproveData = process(this.teamRequestsToApprove, this.state);
  }

  public teamRequestTypesChange(teamRequestTypeId: number, filterService: FilterService): void {

    const [filter] = flatten(this.state).filter(x => x.field === 'typeId');

    if (teamRequestTypeId) {
      if (!filter) {
        this.state.filter.filters.push({
          field: "typeId",
          operator: "eq",
          value: teamRequestTypeId
        });
      }
      else {
        filter.value = teamRequestTypeId;
      }

      this.selectedTeamRequestsTypeId = this.teamRequestsTypes.filter(x => x.id === teamRequestTypeId)[0].id;
    }
    else {
      this.state.filter.filters = flatten(this.state).filter(x => x.field !== 'typeId');
      this.selectedTeamRequestsTypeId = undefined;
    }

    this.teamRequestsToApproveData = process(this.teamRequestsToApprove, this.state);
    filterService.filter(this.state.filter);

    console.log("teamRequestTypesChange");
  }

  public organisationUnitChange(organisationUnitId: number, filterService: FilterService): void {

    const [filter] = flatten(this.state).filter(x => x.field === 'organisationUnitId');

    if (organisationUnitId) {
      if (!filter) {
        this.state.filter.filters.push({
          field: "organisationUnitId",
          operator: "eq",
          value: organisationUnitId
        });
      }
      else {
        filter.value = organisationUnitId;
      }

      this.selectedTeamRequestsOrganisationUnitId = this.teamRequestsOrganisationUnits.filter(x => x.id === organisationUnitId)[0].id;
    }
    else {
      this.state.filter.filters = flatten(this.state).filter(x => x.field !== 'organisationUnitId');
      this.selectedTeamRequestsOrganisationUnitId = undefined;
    }

    this.teamRequestsToApproveData = process(this.teamRequestsToApprove, this.state);
    filterService.filter(this.state.filter);

    console.log("organisationUnitChange");
  }

  public teamRequestStateChange(teamRequestStateId: number, filterService: FilterService): void {

    const [filter] = flatten(this.state).filter(x => x.field === 'stateId');

    if (teamRequestStateId) {
      if (!filter) {
        this.state.filter.filters.push({
          field: "stateId",
          operator: "eq",
          value: teamRequestStateId
        });
      }
      else {
        filter.value = teamRequestStateId;
      }

      this.selectedTeamRequestsStateId = this.teamRequestsStates.filter(x => x.id === teamRequestStateId)[0].id;
    }
    else {
      this.state.filter.filters = flatten(this.state).filter(x => x.field !== 'stateId');
      this.selectedTeamRequestsStateId = undefined;
    }

    this.teamRequestsToApproveData = process(this.teamRequestsToApprove, this.state);
    filterService.filter(this.state.filter);

    console.log("teamRequestStateChange");
  }


  // approves the team request and creates the Ms Team
  public approve(teamRequestId: string) {
    this._teamsRequestsService.approve(teamRequestId).then(() => {
      // Success
      var msg = 'The Team Request has been approved and the Ms Team has been created successfully';
      this.showSuccess(msg);
      this.loadData();
    }).catch((error: any) => {
      var msg = 'The Team Request could\'n be created: ' + error;
      this.showError(msg);
      console.error(error);
    });   
  }

  // denies the team request
  public deny(teamRequestId: string) {
    this._teamsRequestsService.deny(teamRequestId).then(() => {
      // Success
      var msg = 'The Team Request has been denied successfully';
      this.loadData();
    }).catch((error: any) => {
      var msg = 'The Team Request could\'n be denied: ' + error;
      this.showError(msg);
      console.error(error);
    });   
  }

  public onShowAllChange(isChecked) {
    this.isShowAllChecked = isChecked;
    this.loadData();
  }


  private showSuccess(msg): void {
    this._notificationService.show({
      content: msg,
      hideAfter: 4000,
      animation: { type: 'fade', duration: 400 },
      type: { style: 'success', icon: true }
    });
  }

  private showError(msg): void {
    this._notificationService.show({
      content: msg,
      hideAfter: 4000,
      animation: { type: 'fade', duration: 400 },
      type: { style: 'error', icon: true }
    });
  }

  // gets the data
  private loadData(): void {
    this._teamsRequestsService.getToApprove(this.actualUser, this.isShowAllChecked).subscribe(data => {

      this.teamRequestsToApprove = data;

      this.teamRequestsTypes = distinctTeamRequestTypes(data);
      this.teamRequestsOrganisationUnits = distinctRequestOrganisationUnits(data);
      this.teamRequestsStates = distinctTeamRequestStates(data);

      this.teamRequestsToApproveData = process(data, this.state);

    }); 
  }

  

}
